<template>
  <v-row>
    <v-col cols="12">
      <div id="container"></div>
      <v-col
        cols="12"
        align-self="center"
        class="align-center justify-center mt-n3"
        align="center"
      >
        <h3 style="color: white" v-if="this.$vuetify.breakpoint.name === 'xs'">
          {{ availability.suffix }}
        </h3>
        <h2 style="color: white" v-else>{{ availability.suffix }}</h2>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import Acessibility from "highcharts/modules/accessibility";
Acessibility(Highcharts);
Exporting(Highcharts);
export default {
  props: ["availability"],
  name: "WaterAvailabilityChart",
  date() {
    return {
      legend: "",
    };
  },
  mounted() {
    this.dataSource();
  },
  methods: {
    async dataSource() {
      this.chartPreprocessing();
    },
    chartPreprocessing() {
      const elementId = "container";
      let chart = document.getElementById(elementId);
      if (this.availability) {
        this.charts(this.availability);
        this.loading = false;
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }
    },
    async charts(availability) {
      Highcharts.chart("container", {
        chart: {
          type: "gauge",
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          height: 100,
        },
        title: { text: null },
        subtitle: { text: null },
        exporting: { enabled: false },
        credits: { enabled: false },
        pane: {
          center: ["50%", "85%"],
          size: "150%",
          startAngle: -90,
          endAngle: 90,
          background: null,
        },
        plotOptions: {
          gauge: {
            pivot: {
              radius: 3,
            },
            dial: {
              borderWidth: 0,
              baseWidth: 2,
            },
            dataLabels: {
              enabled: false,
            },
          },
        },
        // the value axis
        yAxis: {
          reversed: true,
          min: 0,
          max: 100,
          minorTickInterval: "auto",
          minorTickWidth: 0,
          minorTickLength: 0,
          minorTickPosition: "outside",
          minorTickColor: "transparent",
          tickPixelInterval: 100,
          tickWidth: 0,
          tickPosition: "outside",
          tickLength: 0,
          tickColor: "transparent",
          lineWidth: 0,
          //minorTickInterval: 1,
          tickPositions: [5, 25, 75, 95],
          tickAmount: 2,
          labels: {
            enabled: false,
            rotation: "top",
            verticalAlign: "top",
            y: 5,
            x: 0,
            align: "center",
            distance: "62%",
            //align: 'auto',
            style: {
              color: "#FFFFFF",
            },
          },
          title: { text: null },
          subtitle: { text: null },
          plotBands: [
            {
              from: 0,
              to: 5,
              color: "#8F5FE8",
              thickness: "26%",
            },
            {
              from: 5,
              to: 25,
              color: "#00D25B",
              thickness: "26%",
            },
            {
              from: 25,
              to: 75,
              color: "#0090E7",
              thickness: "26%",
            },
            {
              from: 75,
              to: 95,
              color: "#FFAB00",
              thickness: "26%",
            },
            {
              from: 95,
              to: 100,
              color: "#FC424A",
              thickness: "26%",
            },
          ],
        },
        tooltip: {
          enabled: true,
        },
        series: [
          {
            name: "Disponibilidade",
            data: [availability.q30],
            tooltip: {
              pointFormat: "<b>{point.y} %</b>",
              //valueSuffix: availability.suffix
            },
          },
        ],
        // caption:{
        //   text: 'Card Disponibilidade Hídrica',
        //   style: { color: '#FFFFFF'},
        // }
      });
    },
  },
};
</script>

<style>
.highcharts-gauge-series .highcharts-dial {
  fill: white;
}
.highcharts-gauge-series .highcharts-pivot {
  stroke: white;
  fill: white;
  stroke-width: 0;
}
</style>
